import List from "./list";
import User from "../models/user";
import { excuseApi } from "../commons/http";

export default class Users extends List {
  constructor() {
    super();
    this.total = 0;
  }

  async fetch(page = 0, per_page = 10, params = {}, searchQuery = '') {
    const res = await excuseApi({
      path: '/users',
      method: 'GET',
      params: {
        page: page,
        per_page: per_page,
        name: searchQuery,
        ...params,
      }
    });
    if (res.status === 200) {
      this.clear();
      this.total = res.data.total;
      this.mapData(res.data.data);
    }
  }

  mapData(data = []) {
    for (const item of data) {
      const user = new User();
      user.mapData(item);
      this.add(user);
    }
  }

  async fetchInactive(days) {
    try {
      const res = await excuseApi({
        path: '/users/inactive',
        method: 'GET',
        params: {
          days: days,
        }
      });

      if (res.status === 200) {
        this.mapData(res.data.data);
      }
    } catch (error) {
      throw error;
    }
  }
}
